import React, { Fragment, useState, useEffect, useMemo } from "react";
// import Breadcrumb from "../../../layout/breadcrumb";
import Breadcrumbs from "../../../../layout/breadcrumb";
import { Badge, Button } from "reactstrap";
// import SearchStaticCommissions from "./search-static-commissions";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { deleteProductClientByClientId_ } from "../../../../api";
import { getProductClientByClientId, getCompanyById } from "../../../../api";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import formatedDate from "../../../../utilities/formatedDate";
import SweetAlert from "sweetalert2";
import GetButtons from "../../../common/getButtons";
import GetExport from "../../../common/getExport";

const AssignedProductsToClient = () => {
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState({});

  const { company_id } = useParams();

  useEffect(() => {
    fetchProductClientByClientId();
    fetchCompanyById(company_id);
  }, [company_id]);

  const fetchCompanyById = async (companyId) => {
    try {
      const response = await getCompanyById(companyId);
      setCompanyData(response.data.result); // Set company data in state
    } catch (error) {
      console.error("Error fetching company data:", error);
      toast.error(error.response.data.error);
    }
  };

  const fetchProductClientByClientId = async () => {
    setIsLoading(true);
    await getProductClientByClientId(company_id)
      .then((res) => {
        setIsLoading(false);
        setProductData(res.data.result);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
      });
  };

  const refresh = () => {
    fetchProductClientByClientId();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "product.product_name",
        header: "Product Name",
        filter: false,
        enableClickToCopy: false,
        size: 80,
      },
      {
        accessorKey: "created_at",
        // header: 'Created Date',
        header: "Assigned Date",
        filter: false,
        enableClickToCopy: false,
        // size: 80,
        size: 400,
        Cell: ({ row }) => <div>{formatedDate(row.original.created_at)}</div>,
      },
      {
        accessorKey: "status",
        header: "Status",
        // filter: false,
        enableSorting: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        size: 10,
        // filterSelectOptions: [
        //   { text: 'Active', value: "Active" },
        //   { text: 'Deactivate', value: "Deactivate" },
        // ],
        filterVariant: "select",
        Cell: ({ row }) => {
          const isActive = row?.original?.product?.is_active;
          const status = isActive ? "ACTIVE" : "DEACTIVATE";
          
          return (
            <div>
              <Badge
                color={isActive ? "success" : "danger"}
              >
                {status}
              </Badge>
            </div>
          );
        },
      },
      // {
      //   accessorKey: 'action',
      //   header: 'Action',
      //   filter: false,
      //   enableClickToCopy: false,
      //   Cell: ({ row }) => {
      //     return (
      //       <div>
      //         <FontAwesomeIcon
      //           icon={faTrash}
      //           onClick={() => handleDelete(row)}
      //           style={{ color: "red", cursor: "pointer" }}
      //         />
      //       </div>
      //     );
      //   },
      // },
    ],
    []
  );

  const exportedData = productData.map((item) => ({
    Product: item.product?.product_name,
    Created_on: formatedDate(item.created_at),
  }));

  return (
    <Fragment>
      <Breadcrumbs
        parent="Affiliations"
        title={
          companyData?.client_company_name
            ? `Assigned Products for ${companyData.client_company_name}`
            : "Client not found !"
        }
      />

      <div>
        {companyData?.client_company_name ? (
          <MaterialReactTable
          enableSorting={false}
            columns={columns}
            data={productData}
            initialState={{ density: "compact" }}
            defaultColumn={{
              maxSize: 400,
              minSize: 80,
              size: 100, //default size is usually 180
            }}
            // enableColumnResizing
            columnResizeMode="onChange" //default
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "0.3rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <GetButtons onClick={refresh} type="refresh" />
                {/* <GetButtons onClick={null} type="export" /> */}
                <GetExport
                  columns={columns}
                  exportedData={exportedData}
                  name={
                    companyData?.client_company_name
                      ? `Assigned Products for ${companyData.client_company_name}`
                      : "Client not found !"
                  }
                />
              </Box>
            )}
            state={{
              isLoading,
            }}
          />
        ) : (
          ""
        )}
      </div>
    </Fragment>
  );
};

export default AssignedProductsToClient;
